import './styles.scoped.css'
import {useState, useEffect} from 'react'
import {Typography, Button, TextField, Select, InputAdornment, MenuItem, FormControl, Checkbox, ListItemText, Tooltip, Skeleton} from '@mui/material'
import {Add, List, DateRange, Search} from '@mui/icons-material'
import {useMobile} from '../../hooks'
import {ScheduleVisits, CalendarView} from './components'
import {DatePicker as DatePickerAntd} from 'antd'
import dayjs from 'dayjs'
import {useNavigate} from 'react-router-dom'

export default () => {
    const [calendarView, setCalendarView] = useState(false)
    const {mobile} = useMobile()
    const navigate = useNavigate()
    const {RangePicker} = DatePickerAntd
    const [search, setSearch] = useState(null)
    const [searchTyping, setSearchTyping] = useState(null)
    const [startDate, setStartDate] = useState(dayjs())
    const [endDate, setEndDate] = useState(dayjs())
    const statuses = [
        {id: 'scheduled', display_name: 'Scheduled'},
        {id: 'in_progress', display_name: 'In Progress'},
        {id: 'completed', display_name: 'Completed'},
        {id: 'cancelled', display_name: 'Cancelled'},
        {id: 'ended', display_name: 'Ended'},
        {id: 'finished', display_name: 'Finished'},
    ]
    const [selectedStatuses, setSelectedStatuses] = useState(statuses.map(r => r.id))
    const [visitStats, setVisitStats] = useState(null)
    const [dateRangePopup, setDateRangePopup] = useState(false)

    useEffect(() => {
        if (mobile) {
            setCalendarView(false)
        }
    }, [mobile])

    useEffect(() => {
        const timeout = setTimeout(() => {
            setSearch(searchTyping)
        }, 1000)
        return () => clearTimeout(timeout)
    }, [searchTyping])

    const statusChange = event => {
        const value = event.target.value
        if (value.includes('all')) {
            if (selectedStatuses.length === statuses.length) {
                setSelectedStatuses([])
            } else {
                setSelectedStatuses(statuses.map(r => r.id))
            }
        } else {
            setSelectedStatuses(value)
        }
    }

    const renderStatusLabel = selecteds => {
        if (selecteds.length === statuses.length) {
            return 'All Statuses'
        }
        return statuses
            .filter(r => selecteds.includes(r.id))
            .map(r => r.display_name)
            .join(', ')
    }

    return (
        <>
            {mobile ? (
                <Button variant="contained" startIcon={<Add />} fullWidth onClick={() => navigate('/scheduling/schedule-form')}>
                    Create Schedule
                </Button>
            ) : (
                <>
                    <div className="header">
                        <Typography variant="h6" color="text.primary">
                            Schedule
                        </Typography>
                        <div className="toolbox-container">
                            <div className="toolbox">
                                <Tooltip title="Table View">
                                    <div className={calendarView ? '' : 'toolbox-selected'} onClick={() => setCalendarView(false)}>
                                        <List />
                                    </div>
                                </Tooltip>
                                <span>|</span>
                                <Tooltip title="Calendar View">
                                    <div className={calendarView ? 'toolbox-selected' : ''} onClick={() => setCalendarView(true)}>
                                        <DateRange />
                                    </div>
                                </Tooltip>
                            </div>
                            <Button variant="contained" startIcon={<Add />} onClick={() => navigate('/scheduling/schedule-form')}>
                                Create Schedule
                            </Button>
                        </div>
                    </div>
                </>
            )}
            <br />
            <br />
            <div className="summary">
                <div className="summary-card">
                    <Typography variant="caption" color="text.secondary">
                        #scheduled
                    </Typography>
                    <br />
                    <Typography variant="h8" color="text.primary">
                        {visitStats ? visitStats.scheduled : <Skeleton variant="text" width={24} sx={{fontSize: 16, display: 'inline-block'}} />}
                    </Typography>
                </div>
                <div className="summary-card">
                    <Typography variant="caption" color="text.secondary">
                        #In progress
                    </Typography>
                    <br />
                    <Typography variant="h8" color="text.primary">
                        {visitStats ? visitStats.in_progress : <Skeleton variant="text" width={24} sx={{fontSize: 16, display: 'inline-block'}} />}
                    </Typography>
                </div>
                <div className="summary-card">
                    <Typography variant="caption" color="text.secondary">
                        #Pending Approval
                    </Typography>
                    <br />
                    <Typography variant="h8" color="text.primary">
                        {visitStats ? (
                            visitStats.pending_approval
                        ) : (
                            <Skeleton variant="text" width={24} sx={{fontSize: 16, display: 'inline-block'}} />
                        )}
                    </Typography>
                </div>
                <div className="summary-card">
                    <Typography variant="caption" color="text.secondary">
                        #Completed
                    </Typography>
                    <br />
                    <Typography variant="h8" color="text.primary">
                        {visitStats ? visitStats.completed : <Skeleton variant="text" width={24} sx={{fontSize: 16, display: 'inline-block'}} />}
                    </Typography>
                </div>
                <div className="summary-card">
                    <Typography variant="caption" color="text.secondary">
                        #Cancelled
                    </Typography>
                    <br />
                    <Typography variant="h8" color="text.primary">
                        {visitStats ? visitStats.cancelled : <Skeleton variant="text" width={24} sx={{fontSize: 16, display: 'inline-block'}} />}
                    </Typography>
                </div>
            </div>
            <br />
            <div className={mobile ? '' : 'filter'}>
                <TextField
                    placeholder="Search caregiver or service name ..."
                    style={{flex: 2}}
                    fullWidth={mobile}
                    onChange={e => setSearchTyping(e.target.value)}
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search />
                                </InputAdornment>
                            ),
                        },
                    }}
                />
                {mobile ? (
                    <>
                        <br />
                        <br />
                        <RangePicker
                            value={startDate && endDate ? [startDate, endDate] : [null, null]}
                            onChange={e => {
                                const [start_date, end_date] = e
                                setStartDate(start_date)
                                setEndDate(end_date)
                            }}
                            format="MM/DD/YYYY"
                            allowClear={false}
                            style={{
                                borderRadius: 16,
                                border: '1px solid #0000003B',
                                backgroundColor: '#fbfbfb',
                                height: 56,
                                color: '#00000099',
                                width: dateRangePopup ? 600 : '100%',
                            }}
                            placement="bottomRight"
                            onOpenChange={open => setDateRangePopup(open)}
                        />
                    </>
                ) : (
                    <>
                        <FormControl style={{flex: 1}}>
                            <Select
                                multiple
                                value={selectedStatuses}
                                onChange={statusChange}
                                renderValue={renderStatusLabel}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                        },
                                    },
                                }}>
                                <MenuItem value="all">
                                    <Checkbox
                                        checked={selectedStatuses.length === statuses.length}
                                        indeterminate={selectedStatuses.length > 0 && selectedStatuses.length < statuses.length}
                                    />
                                    <ListItemText primary="Select All" />
                                </MenuItem>
                                {statuses.map(item => (
                                    <MenuItem key={item.id} value={item.id}>
                                        <Checkbox checked={selectedStatuses.includes(item.id)} />
                                        <ListItemText primary={item.display_name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl style={{flex: 1}}>
                            <RangePicker
                                value={startDate && endDate ? [startDate, endDate] : [null, null]}
                                onChange={e => {
                                    const [start_date, end_date] = e
                                    setStartDate(start_date)
                                    setEndDate(end_date)
                                }}
                                format="MM/DD/YYYY"
                                allowClear={false}
                                style={{
                                    borderRadius: 16,
                                    border: '1px solid #0000003B',
                                    height: 56,
                                    color: '#00000099',
                                }}
                                placement="bottomRight"
                            />
                        </FormControl>
                    </>
                )}
            </div>
            <br />
            <div style={{display: calendarView ? 'none' : 'inline'}}>
                <ScheduleVisits
                    search={search}
                    statuses={statuses}
                    selectedStatuses={selectedStatuses}
                    setSelectedStatuses={setSelectedStatuses}
                    startDate={startDate}
                    endDate={endDate}
                    calendarView={calendarView}
                    setVisitStats={setVisitStats}
                />
            </div>
            <div style={{display: calendarView ? 'inline' : 'none'}}>
                <CalendarView
                    search={search}
                    statuses={statuses}
                    selectedStatuses={selectedStatuses}
                    startDate={startDate}
                    endDate={endDate}
                    calendarView={calendarView}
                    setVisitStats={setVisitStats}
                />
            </div>
        </>
    )
}
